// extracted by mini-css-extract-plugin
module.exports = {"cardSegment":"Card-CardSegment-module--card-segment--1HgMu","noBorder":"Card-CardSegment-module--noBorder--rACei"};